import { ReactNode } from "react";
import { BorderedIcon } from "../BorderedIcon";

export type IconButtonProps = {
  icon: ReactNode;
  rounded?: boolean;
  onClick?: () => void;
};

export const IconButton = ({ icon, rounded, onClick }: IconButtonProps) => {
  return (
    <button type="button" className="flex items-center gap-3" onClick={onClick}>
      <BorderedIcon
        className="bg-transparent hover:bg-gray-25 text-gray-400"
        rounded={rounded}
      >
        {icon}
      </BorderedIcon>
    </button>
  );
};
